import { useState, useContext, useEffect } from 'react'
import { IntakeContext } from '../context/IntakeContext'
import styled from 'styled-components'
// import { Link } from "react-router-dom";

// @mui material components
import Grid from '@mui/material/Grid'

// Soft UI Dashboard PRO React components
import SoftBox from 'components/SoftBox'
import SoftTypography from 'components/SoftTypography'

// Wizard application components
import FormField from 'components/FormField'

function TellUsAboutYourself({ isRetired = false }) {
  const { intakeState, updateIntakeStateAtKey } = useContext(IntakeContext)
  const [retirementSystem, setRetirementSystem] = useState(
    intakeState?.retirementSystem
  )
  const [dateOfHire, setDateOfHire] = useState(intakeState?.dateOfHire)
  const [dateOfBirth, setDateOfBirth] = useState(intakeState?.dateOfBirth)
  const [tspBalance, setTspBalance] = useState(intakeState?.tspBalance)

  useEffect(() => {
    updateIntakeStateAtKey({ retirementSystem })
  }, [retirementSystem])
  useEffect(() => {
    updateIntakeStateAtKey({ dateOfHire })
  }, [dateOfHire])
  useEffect(() => {
    updateIntakeStateAtKey({ dateOfBirth })
  }, [dateOfBirth])
  useEffect(() => {
    updateIntakeStateAtKey({ tspBalance })
  }, [tspBalance])
  const handleSelect = (e) => {
    // console.log(e);
    setRetirementSystem(e.target.value)
  }

  const SelectInput = styled.select`
    display: flex;
    width: 100%;
    height: 2.5rem;
    font-size: 0.875rem;
    padding: 0 0.75rem;
    border-radius: 0.5rem;
    border: 0.0625rem solid #d2d6da;
    color: #344767;
    letter-spacing: 0.00938em;
    font-family: Roboto;
    cursor: pointer;
    text-transform: capitalize;
    margin-top: 3px;
    &:active,
    &:focus,
    &:focus-visible {
      border-color: #17c1e8;
      box-shadow: 0 0 0 0.125rem rgba(129, 227, 249);
    }
  `

  return (
    <SoftBox>
      <SoftBox width="80%" textAlign="center" mx="auto">
        <SoftBox mb={1}>
          <SoftTypography variant="h5" fontWeight="regular">
            Final Required Details
          </SoftTypography>
        </SoftBox>
        <SoftTypography variant="body2" fontWeight="regular" color="text">
          Provide some final details so we can get to work for you.
        </SoftTypography>
      </SoftBox>
      <SoftBox mt={2}>
        {intakeState?.employmentStatus === 'retired' ? (
          <Grid container justifyContent="center" spacing={3}>
            <Grid item xs={12} md={6}>
              <FormField
                type="number"
                label="TSP Balance"
                name="tspBalance"
                placeholder="XXXXXX"
                value={tspBalance}
                onChange={(e) => setTspBalance(e.target.valueAsNumber)}
              />
            </Grid>
          </Grid>
        ) : (
          <>
            <Grid container justifyContent="center" spacing={3}>
              <Grid item xs={12} md={6}>
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  What is your retirement system?
                </SoftTypography>
                <SelectInput
                  name="retirementSystem"
                  value={retirementSystem}
                  onChange={handleSelect}
                >
                  <option value="">Select retirement system</option>
                  <option value="fers">FERS</option>
                  <option value="csrs">CSRS</option>
                  <option value="csrs_offset">CSRS Offset*</option>
                  <option value="special_fers_(leo,_atc_etc.)">
                    Special FERS (LEO, ATC etc.)
                  </option>
                  <option value="ecbpo_(cbp_federal_employees)">
                    eCBPO (CBP Federal Employees)
                  </option>
                  <option value="private_sector_-_no_pension">
                    Private Sector - No Pension
                  </option>
                  <option value="federal_reserve_system_retirement_plan">
                    Federal Reserve System Retirement Plan
                  </option>
                  <option value="foreign_service_officer_pension_(fsps)">
                    Foreign Service Officer Pension (FSPS)
                  </option>
                  <option value="foreign_service_officer_limited_(fs_-_ltd)">
                    Foreign Service Officer Limited (FS - LTD)
                  </option>
                </SelectInput>
              </Grid>
            </Grid>
            <Grid container justifyContent="center" spacing={3} pt={2}>
              <Grid item xs={12} md={6}>
                <FormField
                  type="date"
                  label="What is your Service Computation Date?"
                  name="dateOfHire"
                  placeholder="01/01/1970"
                  value={dateOfHire}
                  onChange={(e) => setDateOfHire(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormField
                  type="date"
                  label="What is your Date of Birth?"
                  name="dateOfBirth"
                  placeholder="01/01/1970"
                  value={dateOfBirth}
                  onChange={(e) => setDateOfBirth(e.target.value)}
                />
              </Grid>
            </Grid>
          </>
        )}
        {/* <Grid container justifyContent="center" spacing={3} pt={2}>
          <Grid item xs={12} md={6}>
            <FormField
              type="date"
              label="What is your Date of Birth?"
              name="dateOfBirth"
              placeholder="01/01/1970"
              value={dateOfBirth}
              onChange={(e) => setDateOfBirth(e.target.value)}
            />
          </Grid>
        </Grid> */}
      </SoftBox>
    </SoftBox>
  )
}

export default TellUsAboutYourself
